<template>
  <v-subheader class="d-flex align-start" style="height: 30px;padding-right: 0;max-width: 200px;">
    <label :style="{ fontSize: `${size}px !important` }" class="label-field--label">
      {{ label }}
    </label>
  </v-subheader>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 14
    }
  }
};
</script>

<style module lang="scss"></style>
